<template>
  <div class="goodList">
    <router-link
      :to="{ path: '/detail/' + item.id }"
      class="item acea-row row-between-wrapper"
      v-for="(item, index) in goodList"
      :key="index"
    >
      <div class="pictrue">
        <img :src="item.image" class="image" />
        <img :src="icon" class="icon"/>
        <img src="@assets/images/one.png" class="numPic" v-if="isSort === true && index === 0" />
        <img src="@assets/images/two.png" class="numPic" v-if="isSort === true && index === 1" />
        <img src="@assets/images/three.png" class="numPic" v-if="isSort === true && index === 2" />
      </div>
      <div class="underline">
        <div class="text">
          <div class="line1">{{ item.store_name }}</div>
           <div class="vip-money acea-row row-middle">
            <div class="vip" v-if="item.vip_price && item.vip_price > 0">
              ￥{{ item.vip_price || 0
              }}
              <img src="@assets/images/vip.png" class="image" />
            </div>
            <span class="num">{{item.store_info}}</span>
          </div>
          <div class="money font-color-red">
            ￥
            <span class="num">{{ item.price }}</span>
          </div>
        </div>
      </div>
      <div
        class="iconfont  acea-row row-center-wrapper"
      @click="promotion(item.id)">推广</div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "GoodList",
  props: {
    icon:{
      type:Object
    },
    goodList: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {};
  },
  methods:{
    promotion:function(id){
      this.$router.push({path:'/detail/'+id+'?poster=1'})
    }
  }
};
</script>
<style scoped>
.goodList {
  margin-top:0.3rem;
  justify-content: space-around;
  display: flex;
  flex-wrap: row;
  flex-wrap: wrap;
}
.goodList .item .pictrue{width:3.0rem;height:3.0rem;position:relative;}
.goodList .item .pictrue .icon{position: absolute;right:0;height:1rem;width:1rem;}
.goodList .item{width:3.4rem;}
.goodList .item .text{width:3.0rem;}
.goodList .item .text{margin-top:0rem;}
.goodList .item .text .money{margin-top:0.3rem;}
</style>
